// import { Link, useNavigate } from "react-router-dom";

// export const SideBar = () => {
//   const navigator = useNavigate();

//   const logoutHandler = () => {
//     localStorage.removeItem("token");

//     navigator("/");
//     window.location.reload();
//   };
//   return (
//     <>
//       <div className="sidebar" data-background-color="dark">
//         <div className="sidebar-logo">
//           <div className="logo-header" data-background-color="dark">
//             <div className="nav-toggle">
//               <button className="btn btn-toggle toggle-sidebar">
//                 <i className="gg-menu-right"></i>
//               </button>
//               <button className="btn btn-toggle sidenav-toggler">
//                 <i className="gg-menu-left"></i>
//               </button>
//             </div>
//             <button className="topbar-toggler more">
//               <i className="gg-more-vertical-alt"></i>
//             </button>
//           </div>

//           <div className="sidebar-wrapper scrollbar scrollbar-inner">
//             <div className="sidebar-content">
//               <ul className="nav nav-secondary">
//                 <li className="nav-item">
//                   <Link to="/student">
//                     <i className="fas fa-home"></i>
//                     <p>Dashboard</p>
//                   </Link>
//                 </li>
//                 <li className="nav-item">
//                   <Link to="/student/study">
//                     <i className="fas fa-graduation-cap"></i>
//                     <p>Study progress</p>
//                   </Link>
//                 </li>

//                 <li className="nav-item">
//                   <Link
//                     data-bs-toggle="collapse"
//                     to="#settings"
//                     className="collapsed"
//                     aria-expanded="false"
//                   >
//                     <i className="fas fa-cog"></i>
//                     <p>Settings</p>
//                     <span className="caret"></span>
//                   </Link>
//                   <div className="collapse" id="settings">
//                     <ul className="nav nav-collapse">
//                       <li>
//                         <Link to="/student/profile">
//                           <span className="sub-item">My profile</span>
//                         </Link>
//                       </li>
//                       <li>
//                         <Link to="/student/password">
//                           <span className="sub-item">Change password</span>
//                         </Link>
//                       </li>
//                     </ul>
//                   </div>
//                 </li>

//                 <li className="nav-item">
//                   <Link to="#" className="nav-link" onClick={logoutHandler}>
//                     <i className="fas fa-sign-out-alt"></i>
//                     <p>Sign out</p>
//                   </Link>
//                 </li>
//               </ul>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

import { Link, useNavigate } from "react-router-dom";
export const SideBar = ({
  sidebarOpen,
  setSidebarOpen,
  activeMenu,
  toggleMenu,
  windowWidth,
}) => {
  const navigator = useNavigate();

  const logoutHandler = () => {
    localStorage.removeItem("token");

    navigator("/");
  };
  return (
    <>
      {sidebarOpen && windowWidth < 768 && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark"
          style={{ opacity: 0.5, zIndex: 999 }}
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}

      <nav
        className="text-white p-0 bg-hsts"
        style={{
          width: "250px",
          minHeight: "180vh",
          position: windowWidth < 768 ? "fixed" : "static",
          left: windowWidth < 768 ? (sidebarOpen ? "0" : "-250px") : "auto",
          top: windowWidth < 768 ? "0" : "auto",
          transition: "left 0.3s ease-in-out",
          zIndex: 1000,
          overflowY: "auto",
          display:
            windowWidth >= 768 ? "block" : sidebarOpen ? "block" : "none",
        }}
      >
        <div className="p-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            {sidebarOpen && <h5 className="mb-0">HESTRAS</h5>}
            <button
              className="btn btn-sm btn-outline-light"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              {sidebarOpen ? (
                <i className="fas fa-times"></i>
              ) : (
                <i className="fas fa-bars"></i>
              )}
            </button>
          </div>
        </div>

        {sidebarOpen && (
          <div
            className="p-3 mt-3 overflow-auto"
            style={{ maxHeight: "calc(100vh - 70px)" }}
          >
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link
                  to={"/student"}
                  className="btn btn-dark-2 border-0 w-100 text-start text-white fs-6"
                >
                  <i className="fas fa-home me-2"></i>Dashboard
                </Link>
              </li>
              <li className="mb-2">
                <Link
                  to="/student/study"
                  className="btn btn-dark-2 border-0 w-100 text-start text-white fs-6"
                >
                  <i className="fas fa-graduation-cap"></i> Study progress
                </Link>
              </li>
              <li className="mb-2">
                <button
                  className="btn btn-dark-2 border-0 w-100 text-start text-white"
                  onClick={() => toggleMenu("settings")}
                >
                  <i className="fas fa-cog me-2"></i>Settings
                  <i
                    className={`fas fa-chevron-down float-end ${
                      activeMenu === "settings" ? "rotate" : ""
                    }`}
                  ></i>
                </button>
                {activeMenu === "settings" && (
                  <ul className="list-unstyled ms-3 mt-2 py-2">
                    <li className="mb-2">
                      <Link to="/student/profile" className="text-light ms-4">
                        My profile
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link to="/student/password" className="text-light ms-4">
                        Change password
                      </Link>
                    </li>
                  </ul>
                )}
              </li>
              <li className="mb-2">
                <div
                  className="btn btn-dark-2 border-0 w-100 text-start text-danger"
                  onClick={logoutHandler}
                >
                  <i className="fas fa-sign-out-alt me-2"></i>Sign out
                </div>
              </li>
            </ul>
          </div>
        )}
      </nav>
    </>
  );
};
